import React, { useEffect, useRef, useState } from "react";
import CommonComponent from "../../CommonComponent";
import DashboardReady from "../DashboardReady/DashboardReady";
import useSearchKeyword from "./useSearchKeyword";
// import NormalTable from "../../../../utility/table/NormalTable";
import PermissionControlledCard from "../../../../common/PermissionControlledCard";
import { usePermissions } from "../../../../context/PermissionContext";
import NormalTable from "../../../../utility/table/CampaignTable";
import CampaignFilter from "../../../../utility/table/CampaignFilter";
import { useSearchParams } from "react-router-dom";
import { useOption } from "../../../../context/OptionContext";
import { addColumn } from "../../Common/addColumn";

const SearchKeywords = () => {

  const dashboardReady = localStorage.getItem("dashboard-ready") === "true";
  const permission = usePermissions();
  const [appliedFilters, setAppliedFilters] = useState(null);


  const {
    data,
    categoryId,
    categoryName,
    handleCategoryClick,
    onBreadcrumbClick, handleBreadcrumbNavigation,
    handleParentProductClick,
    campaignSateSequence,
    formattedStart, formattedEnd, selectedRange,
    handleDateChange,
    campaignData,
    addGroupData,
    selectedIds,
    targetData,
    searchData,
    productData,
    setSelectedIds,
    fetchAllTables,
    handleSelectionChange,
    handleCampaignClick,
    handleAdGroupClick,
    handleTargetClick,
    campaignSequence,
    addGroupSequence,
    targetSequence,
    searchSequence,
    productSequence,
    setFilterValue,
    loading,
    handleSearchClick,
    handleProductClick,
    filterValue,
    selectedCampaignIds,
    setSelectedCampaignIds,
    selectedAdGroupIds,
    setSelectedAdGroupIds,
    selectedProductIds,
    setSelectedProductIds,
    selectedTargetIds,
    setSelectedTargetIds,
    selectedSearchIds,
    setSelectedSearchIds,
    selectedCustomerSearchIds,
    setSelectedCustomerSearchIds,
    handleCustomerSearchClick,
    customerSearchSequence,
    customerSearchData,
    getCampaignData,
    getAdGroupData,
    getTargetingData,
    getSearchTermData,
    getCustomerSearchData,
    getProductData


  } = useSearchKeyword();
  const [searchParams, setSearchParams] = useSearchParams();
  const { selectedOption } = useOption();

  useEffect(() => {
    if (!formattedStart || !formattedEnd) return;

    const params = Object.fromEntries([...searchParams]);

    const parsedFilters = {};

    const alwaysArrayKeys = ["status", "matchTypes", "brand" ,"ads_type"]; // keys that should always be treated as arrays

    Object.keys(params).forEach((key) => {
      const value = params[key];

      if (alwaysArrayKeys.includes(key)) {
        // always return array
        parsedFilters[key] = value.includes(",")
          ? value.split(",")
          : [value];
      } else if (value.includes("-") && !value.includes(",")) {
        // range
        parsedFilters[key] = value.split("-").map(Number);
      } else if (value.includes(",")) {
        // normal array
        parsedFilters[key] = value.split(",");
      } else {
        // single value
        parsedFilters[key] = value;
      }
    });

    if (Object.keys(parsedFilters).length > 0) {
      setAppliedFilters(parsedFilters);

      fetchAllTables(
        formattedStart,
        formattedEnd,
        null, null, null, null, null,
        parsedFilters
      );
    } else {
      fetchAllTables(formattedStart, formattedEnd);
    }

  }, [formattedStart, formattedEnd, selectedOption?.id]);

  const updatedCampaignData = campaignData.map(item => ({
    ...item,
    type: "Category"
  }));
  const updatedAddGroupData = addGroupData.map(item => ({
    ...item,
    type: "Category"
  }));
  const updatedTargetData = targetData.map(item => ({
    ...item,
    type: "Category"
  }));
  const updatedsearchData = searchData.map(item => ({
    ...item,
    type: "Category"
  }));
  const updatedproductData = productData.map(item => ({
    ...item,
    type: "Category"
  }));
    const updatedCustomerSearchData = customerSearchData.map(item => ({
    ...item,
    type: "Category"
  }));


  const handleApplyFilters = (filters) => {
    const cleanedFilters = cleanFilters(filters);
    setAppliedFilters(cleanedFilters);

    const params = {};

    Object.keys(cleanedFilters).forEach((key) => {
      const value = cleanedFilters[key];

      if (Array.isArray(value)) {
        // range case
        if (value.length === 2 && typeof value[0] === "number") {
          params[key] = `${value[0]}-${value[1]}`;
        } else {
          params[key] = value.join(",");
        }
      } else {
        params[key] = value;
      }
    });

    setSearchParams(params);

    fetchAllTables(
      formattedStart,
      formattedEnd,
      null, null, null, null, null,
      cleanedFilters
    );
  };

  const cleanFilters = (filters) => {
    const cleaned = {};

    Object.keys(filters).forEach((key) => {
      const value = filters[key];

      if (
        value !== null &&
        value !== "" &&
        !(Array.isArray(value) && value.length === 0)
      ) {
        cleaned[key] = value;
      }
    });

    return cleaned;
  };
    const handleColumnChange = async(selectedCols, allColumns,sectionName) => {
      const formattedColumns = allColumns
        .filter(col => col !== "id")
        .map(col => ({
          key: col,
          visible: selectedCols.includes(col)
        }));
  
      await addColumn({
        data: {
          section_name: sectionName,
          columns: formattedColumns
        }
      });
      if (sectionName === 'ad_keyword_campaign'){
        getCampaignData(formattedStart,formattedEnd);
      }
      else if (sectionName === "ad_keyword_ad_group"){
         getAdGroupData(formattedStart,formattedEnd);
      }
      else if (sectionName === "ad_keyword_target"){
         getTargetingData(formattedStart,formattedEnd);
      }
      else if (sectionName === "ad_keyword_search_term"){
         getSearchTermData(formattedStart,formattedEnd);
      }
      else if (sectionName === "ad_keyword_customer_search_terms"){
         getCustomerSearchData(formattedStart,formattedEnd);
      }
      else if (sectionName === "ad_keyword_product"){
         getProductData(formattedStart,formattedEnd);
      }
    };

  const downloadBtnPermissionTarget = permission?.data?.keyword_insight?.targets?.download_option?.display && permission?.data?.keyword_insight?.targets?.download_option?.allowed
  const downloadBtnPermissionSearch = permission?.data?.keyword_insight?.search_term?.download_option?.display && permission?.data?.keyword_insight?.search_term?.download_option?.allowed
  const downloadBtnPermissionGroup = permission?.data?.keyword_insight?.ad_group?.download_option?.display && permission?.data?.keyword_insight?.ad_group?.download_option?.allowed
  const downloadBtnPermissionCampaign = permission?.data?.keyword_insight?.campaign_name?.download_option?.display && permission?.data?.keyword_insight?.campaign_name?.download_option?.allowed
  const downloadBtnPermissionProduct = permission?.data?.keyword_insight?.product?.download_option?.display && permission?.data?.keyword_insight?.campaign_name?.download_option?.allowed
  const downloadBtnPermissionCustomerSearch = permission?.data?.keyword_insight?.product?.download_option?.display && permission?.data?.keyword_insight?.campaign_name?.download_option?.allowed

  return (
    <>
      <CommonComponent defaultRange={selectedRange} onRangeChange={handleDateChange} categoryId={categoryId} categoryName={categoryName} onBreadcrumbClick={handleBreadcrumbNavigation} />

      {!dashboardReady ? (
        <DashboardReady />
      ) : (
        <>
          <CampaignFilter appliedFilters={appliedFilters} setAppliedFilters={setAppliedFilters} handleApplyFilters={handleApplyFilters} />

          {/* Campaign data table  */}
          <PermissionControlledCard permission={permission?.data?.keyword_insight?.campaign_name?.table_view && permission?.data?.keyword_insight?.campaign_name?.table_view} colClass="col-12">
            <section className="section dashboard py-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="kpi-sub-heading mb-3">Campaigns</h5>
                  {(updatedCampaignData.length > 0) || (loading.campaign) ? (
                    <NormalTable
                      tableId="CampagainName"
                      data={updatedCampaignData}
                      idKey="campaign_id"
                      selectedIds={selectedCampaignIds}
                      onSelectionChange={(row) => {
                        setSelectedCampaignIds(row);
                        handleCampaignClick(row);
                      }}
                      enableSelection={true}
                      title="Campagain Name"
                      downloadBtnPermission={downloadBtnPermissionCampaign}
                      showSearch={false}
                      loading={loading.campaign}
                      sequence={campaignSequence}
                      selectedCheckBoxIds={filterValue?.campaign_id}
                      onColumnChange={handleColumnChange}
                      showSelectColumn={true}
                      section={"ad_keyword_campaign"}
                    />
                  ) : (<div className="d-flex justify-content-center no-data-found">No data found for the given criteria.</div>)}
                </div>
              </div>

            </section>
          </PermissionControlledCard>

          <PermissionControlledCard permission={permission?.data?.keyword_insight?.ad_group?.table_view && permission?.data?.keyword_insight?.ad_group?.table_view} colClass="col-12">
            <section className="section dashboard py-2">
              <div className="card">
                <div className="card-body">
                  <h5 className="kpi-sub-heading mb-3">Ad Group Name</h5>
                  {(addGroupData.length > 0) || (loading.adgroup) ? (
                    <NormalTable
                      tableId="AddGroup"
                      data={updatedAddGroupData}
                      idKey="adgroup_id"
                      // selectedIds={selectedIds}
                      // onSelectionChange={handleAdGroupClick}
                      selectedIds={selectedAdGroupIds}
                      onSelectionChange={(row) => {
                        setSelectedAdGroupIds(row);
                        handleAdGroupClick(row);
                      }}
                      onCategoryClick={handleCategoryClick}
                      enableSelection={true}
                      title="Add Group"
                      onParentProductClick={handleParentProductClick}
                      loading={loading.adgroup}
                      downloadBtnPermission={downloadBtnPermissionGroup}
                      showSearch={false}
                      sequence={addGroupSequence}
                      selectedCheckBoxIds={filterValue?.adgroup_id}
                      onColumnChange={handleColumnChange}
                      showSelectColumn={true}
                      section={"ad_keyword_ad_group"}
                    />
                  ) : (<div className="d-flex justify-content-center no-data-found">No data found for the given criteria.</div>)}
                </div>
              </div>

            </section>
          </PermissionControlledCard>

          {/* Product data table  */}
          <section className="section dashboard py-2">
            <PermissionControlledCard permission={permission?.data?.keyword_insight?.product?.table_view && permission?.data?.keyword_insight?.product?.table_view} colClass="col-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="kpi-sub-heading mb-3">Product</h5>
                  {(productData.length > 0) || (loading.product) ? (
                    <NormalTable
                      tableId="product"
                      data={updatedproductData}
                      idKey="product_id"
                      // selectedIds={selectedIds}
                      // onSelectionChange={handleProductClick}
                      selectedIds={selectedProductIds}
                      onSelectionChange={(row) => {
                        setSelectedProductIds(row);
                        handleProductClick(row);
                      }}
                      onCategoryClick={handleCategoryClick}
                      enableSelection={true}
                      title="Product"
                      onParentProductClick={handleParentProductClick}
                      downloadBtnPermission={downloadBtnPermissionProduct}
                      isProductwiseTable={'product'}
                      showSearch={false}
                      loading={loading?.product}
                      sequence={productSequence}
                      selectedCheckBoxIds={filterValue?.product}
                      onColumnChange={handleColumnChange}
                      showSelectColumn={true}
                      section={"ad_keyword_product"}
                    />
                  ) : (<div className="d-flex justify-content-center no-data-found">No data found for the given criteria.</div>)}
                </div>
              </div>
            </PermissionControlledCard>
          </section>

          {/* Target data table  */}
          <section className="section dashboard py-2">
            <PermissionControlledCard permission={permission?.data?.keyword_insight?.targets?.table_view && permission?.data?.keyword_insight?.targets?.table_view} colClass="col-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="kpi-sub-heading mb-3">Targets</h5>
                  {(targetData.length > 0) || (loading.target) ? (
                    <NormalTable
                      tableId="target"
                      data={updatedTargetData}
                      idKey="targeting"
                      selectedIds={selectedTargetIds}
                      onSelectionChange={(row) => {
                        setSelectedTargetIds(row);
                        handleTargetClick(row);
                      }}
                      enableSelection={true}
                      title="Target"
                      downloadBtnPermission={downloadBtnPermissionTarget}
                      showSearch={false}
                      loading={loading.target}
                      sequence={targetSequence}
                      selectedCheckBoxIds={filterValue?.targeting}
                      onColumnChange={handleColumnChange}
                      showSelectColumn={true}
                      section={"ad_keyword_target"}
                    />
                  ) : (<div className="d-flex justify-content-center no-data-found">No data found for the given criteria.</div>)}
                </div>
              </div>
            </PermissionControlledCard>
          </section>

          <section className="section dashboard py-2">
            <PermissionControlledCard permission={permission?.data?.keyword_insight?.search_term?.table_view && permission?.data?.keyword_insight?.search_term?.table_view} colClass="col-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="kpi-sub-heading mb-3">Customer Search Term</h5>
                  {(customerSearchData.length > 0) || (loading.customerSearch) ? (
                    <NormalTable
                      tableId="customerSearch"
                      data={updatedCustomerSearchData}
                      idKey="customer_search_term"
                      selectedIds={selectedCustomerSearchIds}
                      onSelectionChange={(row) => {
                        setSelectedCustomerSearchIds(row);
                        handleCustomerSearchClick(row);
                      }}
                      enableSelection={true}
                      title="Cutomer Search"
                      downloadBtnPermission={downloadBtnPermissionCustomerSearch}
                      showSearch={false}
                      loading={loading.customerSearch}
                      sequence={customerSearchSequence}
                      selectedCheckBoxIds={filterValue?.customer_search_term}
                      onColumnChange={handleColumnChange}
                      showSelectColumn={true}
                      section={"ad_keyword_customer_search_terms"}
                    />
                  ) : (<div className="d-flex justify-content-center no-data-found">No data found for the given criteria.</div>)}

                </div>
              </div>
            </PermissionControlledCard>
          </section>

          {/* Search term data table  */}
          <section className="section dashboard py-2">
            <PermissionControlledCard permission={permission?.data?.keyword_insight?.search_term?.table_view && permission?.data?.keyword_insight?.search_term?.table_view} colClass="col-12">
              <div className="card">
                <div className="card-body">
                  <h5 className="kpi-sub-heading mb-3">Search Term</h5>
                  {(searchData.length > 0) || (loading.search) ? (
                    <NormalTable
                      tableId="search"
                      data={searchData}
                      idKey="search_term"
                      selectedIds={selectedSearchIds}
                      onSelectionChange={(row) => {
                        setSelectedSearchIds(row);
                        handleSearchClick(row);
                      }}
                      onCategoryClick={handleCategoryClick}
                      enableSelection={false}
                      title="Search"
                      onParentProductClick={handleParentProductClick}
                      downloadBtnPermission={downloadBtnPermissionSearch}
                      showSearch={false}
                      loading={loading.search}
                      sequence={searchSequence}
                      selectedCheckBoxIds={filterValue?.search}
                      onColumnChange={handleColumnChange}
                      showSelectColumn={true}
                      section={"ad_keyword_search_term"}
                    />
                  ) : (<div className="d-flex justify-content-center no-data-found">No data found for the given criteria.</div>)}

                </div>
              </div>
            </PermissionControlledCard>
          </section>

        </>
      )}
    </>
  );
};

export default SearchKeywords;